import React, {PureComponent} from 'react';
import nodataImg from '../../public/no-data.png'

import styles from './index.less';

class NoData extends PureComponent {
    render() {
        return (
            <div className={styles.NoData}>
                <img src={nodataImg} alt="no-data"/>
                <div>暂无数据</div>
            </div>
        );
    }
}

export default NoData;


// WEBPACK FOOTER //
// ./src/components/NoData/index.js